export default __webpack_public_path__ + "static/media/Boots of the Martial Paragon.cdd72b76.jpg";